<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="标题" class="fn-left">
            <el-input v-model="listQuery.knowledge_title" />
          </el-form-item>
          <el-form-item label="适用日期" class="fn-left">
            <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="适用年级" class="fn-left">
            <Select key="10" :selected.sync="listQuery.grade_id" :data="gradeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="适用科目" class="fn-left">
            <Select key="5" :selected.sync="listQuery.subject_id" :data="subjectLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetKnowledgeLists">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddPakcage()">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="ID" prop="knowledge_id" align="center" />
        <el-table-column label="知识点标题" prop="knowledge_title" align="center" />
        <el-table-column label="适用日期" prop="live_date" align="center">
          <template slot-scope="{row}">
            {{ row.begin_date + "~" + row.end_date }}
          </template>
        </el-table-column>
        <el-table-column label="适用年级" prop="grade_name" align="center" />
        <el-table-column label="适用科目" prop="subject_name" align="center" />
        <el-table-column label="适用教材" prop="teaching_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <div v-if="isSmallToday(row.begin_date)">
              <el-button type="text" @click="fnToKnowledgeSetting(row.knowledge_id)">编辑</el-button>
              <el-button type="text" :loading="currentLoading == row.knowledg_id" @click="fnDelete(row.knowledge_id)">删除</el-button>
            </div>
            <div v-if="!isSmallToday(row.begin_date)">
              <el-button type="text" @click="fnToKnowledgeSetting(row.knowledge_id,false)">查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetKnowledgeLists" />
    </div>

  </div>

</template>
<script>

var moment = require('moment')
import Select from '@/components/Select'
import commondata from '@/utils/commondata'
// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

export default {
  name: 'TyyKnowledgeSettingLists',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        knowledge_title: '',
        subject_id: '',
        grade_id: '',
        begin_date: '',
        end_date: '',
        total: 0,
        time: ''
      },
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      packageStatus: commondata.OPEN_STATUS,
      gradeLists: commondata.GRADE_LISTS,
      subjectLists: commondata.TYY_SUBJECT_LISTS,
      currentLoading: ''
    }
  },
  created() {
    this.fnGetKnowledgeLists()
  },
  methods: {
    fnGetKnowledgeLists: function() {
      this.bCreatePackage = false
      this.$http.tyyKnowledgePointList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnAddPakcage: function() {
      this.$router.push({
        path: 'tiyouyouAddKnowledge'
      })
    },
    fnToKnowledgeSetting(id, isEdit) {
      this.$router.push({
        path: 'tiyouyouAddKnowledge',
        query: {
          id,
          isEdit
        }
      })
    },
    isSmallToday(begin_date) {
      return moment().isBefore(begin_date)
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_date = val[0]
        this.listQuery.end_date = val[1]
      } else {
        this.listQuery.begin_date = ''
        this.listQuery.end_date = ''
        this.listQuery.time = []
      }
    },
    fnDelete(knowledge_id) {
      this.$confirm('确认删除选中的知识么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.currentLoading = knowledge_id
        this.$http.tyyDelKnowledgePoint({ knowledge_id }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.currentLoading = ''
            this.fnGetKnowledgeLists()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
